import React from "react"
import { Box } from "./Box"
import { Spinner } from "./gluestack/spinner"

interface LoadingProps {
  size?: "small" | "large"
  color?: string
}

export const Loading: React.FC<LoadingProps> = ({
  size = "large",
  color = "rgb(var(--color-typography-500))",
}) => {
  return (
    <Box className="flex-1 items-center justify-center bg-background-0">
      <Spinner size={size} color={color} />
    </Box>
  )
}
